import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=4d7f5d3e&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=js&"
export * from "./FieldSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7f5d3e",
  null
  
)

export default component.exports